module.exports = __webpack_public_path__ + "static/media/percentage.9f7b5b43.svg";